import request from '../request'

import { storage, constants, util } from '../utils'
import store from '../store'
import { setGlobalIsB3User } from '../store/actions'

export const setB3CompanyInfo = async (
  roleId: string,
  customerId: number,
  userId: string
) => {
  const requestApi =
    roleId === constants.B3Role.SALESREP
      ? request.api.getSalesRepMasquerading
      : request.api.getCompany
  const query = roleId === constants.B3Role.SALESREP ? customerId : userId

  const { companyId, companyName, companyStatus } = await requestApi(
    query as never
  )

  companyStatus && storage.B3CompanyStatus.setValue(companyStatus)
  companyId && storage.B3CompanyId.setValue(companyId)
  companyName && storage.B3CompanyName.setValue(companyName)
}

export const setB3UserInfo = async (customerId: number) => {
  const { roleId, userId, email } = await request.api.getUserRole(customerId)

  storage.B3RoleId.setValue(roleId)
  storage.B3UserId.setValue(userId)
  storage.B3Email.setValue(email)

  await setB3CompanyInfo(roleId, customerId, userId)
}

export default async (customerId: number, storeHash: string) => {
  const bcToken = await request.bcApi.getBcToken()
  if (!bcToken) return

  try {
    const { token } = await request.api.getToken({
      bcToken,
      customerId,
      storeHash,
    })

    storage.B3B2BToken.setValue(token)
    await setB3UserInfo(customerId)
  } finally {
    store.dispatch(setGlobalIsB3User(util.detectB3User()))
  }
}
